import { useState } from 'react'
import { Input } from 'reactstrap'

import { CustomModal } from 'components/common'

const CONFIRM_TEXT = '削除'
const CONFIRM_PLACEHOLDER = `${CONFIRM_TEXT} と入力`

type Props = {
  isOpen: boolean
  isConflict: boolean
  onApprove: () => void
  onCancel: () => void
}

export const CsvAutoRecordsDeleteConfirmDialog = ({ isOpen, isConflict, onApprove, onCancel }: Props) => {
  const [inputText, setInputText] = useState('')

  const handleCancel = () => {
    setInputText('')
    onCancel()
  }

  const handleApprove = () => {
    setInputText('')
    onApprove()
  }

  if (isConflict) {
    return (
      <CustomModal
        isOpen={isOpen}
        title="個人別作業実績数を削除できませんでした"
        approveLabel="閉じる"
        approveColor="secondary"
        approveOutline
        showCancel={false}
        onCancel={handleCancel}
        onApprove={handleCancel}
        onHideNotification={() => {}}
      >
        <div>
          個人別作業実績数を集計中のため削除できませんでした。時間をおいて再度実施していただくか、CSVアップローダーを一時停止した上で再度実施してください。
        </div>
      </CustomModal>
    )
  }

  return (
    <CustomModal
      isOpen={isOpen}
      title="個人別作業実績数の削除"
      approveLabel="削除"
      approveColor="danger"
      approveDisabled={inputText !== CONFIRM_TEXT}
      onCancel={handleCancel}
      onApprove={handleApprove}
      onHideNotification={() => {}}
      submitName="csv-auto-records-delete-confirm-submit"
    >
      <div className="mb-2">個人別作業実績を本当に削除しますか？この操作は取り消せません。</div>
      <div className="mb-2">実行する場合は下に「削除」と入力し、［削除］をクリックしてください。</div>
      <Input value={inputText} onChange={e => setInputText(e.target.value)} placeholder={CONFIRM_PLACEHOLDER} />
    </CustomModal>
  )
}
